<template>
  <v-card class="ma-3">
    <v-tabs background-color="white" color="indigo darken-3 accent-4" left>
      <v-tab>Agroindustrias Cadastradas</v-tab>
      <v-tab>Agroindustrias não Cadastradas</v-tab>
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="agroindustrias"
          :search="search"
          :loading="loading"
          item-key="codAgro"
          class="elevation-1 pa-5"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-account-search"
                  label="Pesquisar..."
                  single-line
                  hide-details
                />
              </v-toolbar-title>
              <v-spacer />
              <router-link
                :to="{
                  name: 'Formulário Agroindustrias',
                  params: {codAgro: 0},
                }"
              >
                <v-btn color="success"> Nova Agroindústria </v-btn>
              </router-link>
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{item}">
            <router-link
              :to="{
                name: 'Formulário Agroindustrias',
                params: {codAgro: item.CodAgroindustria},
              }"
            >
              <v-icon small color="warning" title="Editar agroindústria">
                mdi-pencil
              </v-icon>
            </router-link>
            <v-icon
              small
              class="ml-2"
              color="error"
              title="Excluir agroindústria"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          :headers="headersNaoCadastradas"
          :items="agroindustriasNaoCadastradas"
          :search="search"
          :loading="loading"
          item-key="codAgro"
          class="elevation-1 pa-5"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-account-search"
                  label="Pesquisar..."
                  single-line
                  hide-details
                />
              </v-toolbar-title>
              <v-spacer />
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{item}">
            <router-link
              :to="{
                name: 'Formulário Agroindustrias',
                params: {
                  codAgro: 0,
                  nome: item.industria_nome,
                  cnpj: item.industria_cnpj,
                  primeiroAcesso: 1,
                },
              }"
            >
              <v-icon small color="success" title="Editar agroindústria">
                mdi-plus
              </v-icon>
            </router-link>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      loading: true,
      headers: [
        {
          text: '',
          sortable: false,
          width: '80px',
          value: 'actions',
          align: 'left',
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'Nome',
          width: '200px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'CNPJ',
          value: 'cnpj',
          width: '180px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Captação',
          value: 'captacao',
          width: '120px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Fornecedores',
          value: 'fornecedores',
          width: '120px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Estado',
          value: 'estado.nome',
          width: '200px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Cidade',
          value: 'cidade.nome',
          width: '200px',
        },
      ],
      headersNaoCadastradas: [
        {
          text: '',
          sortable: false,
          width: '80px',
          value: 'actions',
          align: 'left',
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'industria_nome',
          width: '200px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'CNPJ',
          value: 'industria_cnpj',
          width: '180px',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Número de Diagnósticos',
          value: 'qnt',
          width: '200px',
        },
      ],
      agroindustrias: [],
      agroindustriasNaoCadastradas: [],
    }
  },
  created() {
    this.api.get('/agroindustria').then(response => {
      this.agroindustrias = response.data
    })
    this.api
      .get('/agroindustria/getAgroindustriasNaoCadastradas')
      .then(response => {
        this.agroindustriasNaoCadastradas = response.data
        this.loading = false
      })
  },
  methods: {
    deleteItem(item) {
      const index = this.agroindustrias.indexOf(item)
      this.Swal.fire({
        title: 'Apagar Agroindústria',
        text: 'Você tem certeza que deseja remover esta Agroindústria?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#4caf50',
        cancelButtonColor: '#ff5252',
        confirmButtonText: 'Sim, desejo removê-la!',
      }).then(result => {
        if (result.value) {
          this.api.delete('/agroindustria/deleteAgroindustria', {
            params: {
              codAgro: this.agroindustrias[index].CodAgroindustria,
            },
          })
          this.agroindustrias.splice(index, 1)
          this.Swal.fire(
            'Removido!',
            'Esta agroindustria foi removida com sucesso!',
            'success',
          )
        } else {
          this.Swal.fire(
            'Erro',
            'Esta agroindustria não pode ser removida!',
            'error',
          )
        }
      })
    },
  },
}
</script>
